"use strict";
/**
 * ==================================================================================
 * Description:       desc
 * Creation Date:     09/07/16
 * Author:            AMcDaniel
 * ==================================================================================
 */

function create_form_controls_for_attributes(edit_form_context, options) {
    edit_form_context.debugLog("create_form_controls_for_attributes", true);

    var entity_record_fields = ['entity_created_by', 'entity_created_on', 'entity_last_updated_by', 'entity_last_updated_on'],
        header_fields = ['assigned_to_user', 'following_users', 'assigned_to_private_flag', 'following_flag'],
        input_array = [];

    var attributes = (edit_form_context.state.entity_attributes && edit_form_context.state.entity_attributes.attributes) ? edit_form_context.state.entity_attributes.attributes : [];
    if(!options) {
        options = {};
    }
    options.header_fields_input_array = options.header_fields_input_array || [];

    var attribute_options = {
        row_name: null,
        row_array: null,
        prev_same_row: null,
        same_row_count: null,
        type_string_row: null,
        currentSection: null,
        record_fields_box: []
    };

    if(options && options.record_fields_only) {
        attributes = attributes.filter(function(a) {
            return ((entity_record_fields.indexOf(a.field_path) != -1) || (header_fields.indexOf(a.field_path) != -1));
        });
    }

    for (var i = 0; i < attributes.length; i++) {
        var attribute = attributes[i];
        if (!attribute.form_visible) {
            continue;
        }
        if (entity_record_fields.indexOf(attribute.field_path) == -1 && String(attribute.same_row).match(/^entity_record_fields_\d$/)){
            attribute.same_row = "inline_record_fields" + String(attribute.same_row).substr(attribute.same_row.length -2);
        }
        var create_att_args = {
            edit_form_context: edit_form_context,
            attribute: attribute,
            entity_instance: edit_form_context.state.entity_instance,
            attribute_options: attribute_options
        };
        var same_row_cur_value = attribute.same_row, repeat_attribute = false;
        if((header_fields.indexOf(attribute.field_path) != - 1) && (attribute.same_row != "assigned_to_fields")) {
            repeat_attribute = !(options && options.record_fields_only);

            //Fix a fallthrough that occurs with same_row when it is followed immediately by one of these fields:
            if (attribute_options.row_name) { //ending a previous row
                var input_div = <div className="row"
                                     key={"QK-input-wrapper-row-name-"+attribute_options.row_name.toString()+"-"}>{attribute_options.row_array}</div>;
                if (String(attribute_options.row_name).match(/^entity_record_fields_\d$/)){
                    attribute_options.record_fields_box.push(input_div);
                } else {
                    input_array.push(input_div);
                }
            }

            same_row_cur_value = attribute.same_row;
            attribute.same_row = "assigned_to_fields";
        }

        var input_div = create_control_for_attribute(create_att_args);
        if(input_div) {
            if(attribute.same_row == "assigned_to_fields") {
                add_to_list(options.header_fields_input_array, input_div);
            }
            else {
                add_to_list(input_array, input_div);
            }
        }

        attribute.same_row = same_row_cur_value;
        if(repeat_attribute) {
            input_div = create_control_for_attribute(create_att_args);
            if(input_div) {
                add_to_list(input_array, input_div);
            }
        }
    }

    if (attribute_options.row_name) { //ending a previous row
        var input_div = <div className="row"
                         key={"QK-input-wrapper-row-name-"+attribute_options.row_name.toString()+"-"}>{attribute_options.row_array}</div>;
        if (String(attribute_options.row_name).match(/^entity_record_fields_\d$/)){
            attribute_options.record_fields_box.push(input_div);
        } else {
            input_array.push(input_div);
        }
    }

    var element = $('#record-fields-box-test');
    element.children().each(function(e){$(this).children().remove('div');});
    element.parent().show();
    options.record_fields_box_show = attribute_options.record_fields_box && attribute_options.record_fields_box.length > 0 && !element.is(':truncated');
    element.parent().hide();

    options.record_fields_box = attribute_options.record_fields_box;

    edit_form_context.debugLog("create_form_controls_for_attributes", false);
    return input_array;
}

/**
 * Creates a single reactified control for an attribute
 * @param parameters
 * @param use_cached_attributes - same_row logic breaks if cached attributes are used
 * @param is_new_row
 * @returns {*}
 */
function create_control_for_attribute(parameters, use_cached_attributes, is_new_row, is_custom_edit_form) {
    var edit_form_context = parameters.edit_form_context;
    var attribute = parameters.attribute;
    var entity_instance = parameters.entity_instance;
    var attribute_options = parameters.attribute_options;
    var base_field_path = parameters.base_field_path;
    var nested_entity_name = parameters.nested_entity_name;

    if (attribute && nested_entity_name && (nested_entity_name != "")) {
        attribute.parent_entity_name = nested_entity_name;
        edit_form_context.state.individual_attributes_per_entity = edit_form_context.state.individual_attributes_per_entity || {};
        edit_form_context.state.individual_attributes_per_entity[base_field_path] = edit_form_context.state.individual_attributes_per_entity[base_field_path] || {};
        edit_form_context.state.individual_attributes_per_entity[base_field_path][attribute.field_path] = edit_form_context.state.individual_attributes_per_entity[base_field_path][attribute.field_path] || $.extend({}, attribute);
        attribute = edit_form_context.state.individual_attributes_per_entity[base_field_path][attribute.field_path];
        attribute.is_new_row = attribute.is_new_row || is_new_row;
    }

    var attribute_value;
    var attribute_caption_image;

    var entity_access;
    if (edit_form_context.state.entity_attributes.reference_entities[attribute.db_type]) {
        entity_access = edit_form_context.state.entity_attributes.reference_entities[attribute.db_type].entity_access;
    }
    var hasCreateAccess = entity_access && entity_access.indexOf('c') != -1;

    var reference_type =
        (edit_form_context.state.entity_attributes.field_paths[attribute.field_path]
        && edit_form_context.state.entity_attributes.field_paths[attribute.field_path].entity_reference)
        ? edit_form_context.state.entity_attributes.field_paths[attribute.field_path].entity_reference.reference_type
        : undefined;
    var is_user_attribute = reference_type === "user" || reference_type === "org_level_user_data";

    if (!attribute.attribute_is_processed) {
        if (base_field_path && (base_field_path != "")) {
            var full_field_path_from_base_entity = (base_field_path + ":" + attribute.field_path);
            attribute.local_field_path = attribute.field_path;
            attribute.field_path = full_field_path_from_base_entity;
            attribute.nested_entity_name = nested_entity_name;
            if(edit_form_context.state.entity_attributes && edit_form_context.state.entity_attributes.field_paths && edit_form_context.state.entity_attributes.field_paths[attribute.field_path]) {
                delete edit_form_context.state.entity_attributes.field_paths[attribute.field_path].form_visible; //not relevant, usually.
                $.extend(attribute, edit_form_context.state.entity_attributes.field_paths[attribute.field_path]);
            }
        }
        attribute.safe_field_path = (attribute.field_path || "").replace(/\[|]|:/g, ""); //to avoid messing up jquery selectors
        attribute.attribute_is_processed = true;
    }

    attribute_value = get_json_data_using_field_paths(attribute.local_field_path || attribute.field_path, entity_instance);

    if ((attribute_value === undefined)
        && edit_form_context.state.init
        && attribute
        && attribute.is_new_row
        && (attribute.default_value != null)) {
        attribute_value = attribute.default_value;
        set_json_data_using_field_paths(attribute.local_field_path || attribute.field_path, entity_instance, attribute_value);
    }
    attribute_caption_image = null;

    if (attribute_value
        && (typeof attribute_value == "object")
        && attribute.is_nested_entity
        && attribute.data_is_nested == false
        && !attribute.is_array) {
        if (typeof attribute_value.image !== "undefined") {
            if (attribute_value.image) {
                attribute_caption_image = attribute_value.image;
            }
        }

        attribute_value = attribute_value.caption || attribute_value.entity_id;
    }

    var attribute_is_read_only = (attribute.read_only || edit_form_context.form_is_read_only());
    var set_next_focus_element_function = (!attribute.next_focus_element) ? null : function() {
        edit_form_context.set_focus_on_element_by_field_path(attribute.next_focus_element);
    };

    if (attribute.cached_rendered_component && use_cached_attributes) {
        if (attribute_value !== attribute.last_value) {
            attribute.cached_rendered_component = null; //force re-render since value changed
            attribute.last_react_key = null;
            attribute.modified = true;
        }
        else {
            return attribute.cached_rendered_component;
        }
    }

    attribute.last_value = attribute_value;

    var attribute_key_name = attribute.field_path + (attribute.custom_key_tag || "");

    var input_element;
    var input_div;

    var same_row = attribute.same_row;
    if (same_row && attribute_options) {
        attribute_options.row_name = same_row;
        attribute_options.same_row_count = 0;
        attribute_options.type_string_row=0;
        var temp_section = null;
        for (var k = 0; k < edit_form_context.state.entity_attributes.attributes.length; k++) {
            if (!edit_form_context.state.entity_attributes.attributes[k].form_visible) {
                continue;
            }
            if (edit_form_context.state.entity_attributes.attributes[k].attribute_type == "Section") {
                temp_section = edit_form_context.state.entity_attributes.attributes[k].caption;
            }
            if (edit_form_context.state.entity_attributes.attributes[k].same_row
                && (edit_form_context.state.entity_attributes.attributes[k].same_row == attribute_options.row_name)
                && attribute_options.currentSection == temp_section) {
                if (edit_form_context.state.entity_attributes.attributes[k].attribute_type == "String"
                    || edit_form_context.state.entity_attributes.attributes[k].attribute_type == "zipcode_field"
                    || edit_form_context.state.entity_attributes.attributes[k].attribute_type == "DateTime"
                    || edit_form_context.state.entity_attributes.attributes[k].attribute_type == "DateTimeLocal")
                {
                    attribute_options.type_string_row++;
                }

                attribute_options.same_row_count++;

                if (attribute_options.row_array == null) {
                    attribute_options.row_array = [];
                }
            }
        }
    }

    input_element = undefined;
    var omit_caption = attribute.hide_caption;
    if (attribute.is_array && attribute.is_nested_entity && attribute.data_is_nested) {
        var entity = attribute.db_type;
        var nested_list_entities = edit_form_context.state.nested_list_entities;
        if (edit_form_context.props.data && edit_form_context.props.data.nested_list_entities) {
            nested_list_entities = edit_form_context.props.data.nested_list_entities;
        }
        var data_list_object = nested_list_entities[entity];
        var app_object = data_list_object.app_object;
        if (edit_form_context.form_is_read_only()) {
            app_object.custom_properties.editable = false;
        }
        else {
            app_object.custom_properties.editable = !attribute.read_only;
        }
        var entity_attributes = data_list_object.entity_attributes;
        var entity_instances = attribute_value;
        if (!entity_instances) {
            entity_instance[attribute.field_path] = [];
            entity_instances = entity_instance[attribute.field_path];
        }
        var data_list_key = attribute.field_path;
        if (attribute.last_react_key) {
            data_list_key = attribute.last_react_key;
        }
        else if (use_cached_attributes) {
            attribute.last_react_key = data_list_key + general_utils.create_guid();
            data_list_key = attribute.last_react_key;
        }
        if (attribute.field_path == "xenforma_notes") {
            input_element = (
                <NotesListComponent key={data_list_key}
                                    app_object={app_object}
                                    app_object_handler={edit_form_context.props.app_object_handler}
                                    delete_nested_entity={edit_form_context.delete_nested_entity}
                                    entity_attributes={entity_attributes}
                                    entity_instances={entity_instances}
                                    handle_executing={edit_form_context.props.handle_executing}
                                    is_mobile={edit_form_context.props.is_mobile}
                                    is_open={attribute.expanded || attribute.is_open}
                                    on_change={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                    nested_entity_handler={edit_form_context.nested_entity_handler}
                                    nested_list_entities={nested_list_entities}
                                    parent_entity_array={entity_instances}
                                    parent_entity_field_attribute={attribute}
                                    parent_react_entity={edit_form_context}
                                    read_only={attribute_is_read_only}
                                    set_open_state={edit_form_context.set_open_state.bind(edit_form_context, attribute)} />
            );
        }
        else {
            input_element = (
                <NestedDataListComponent key={data_list_key}
                                         app_object={app_object}
                                         app_object_handler={edit_form_context.props.app_object_handler}
                                         delete_nested_entity={edit_form_context.delete_nested_entity}
                                         entity_attributes={entity_attributes}
                                         entity_instances={entity_instances}
                                         handle_executing={edit_form_context.props.handle_executing}
                                         is_mobile={edit_form_context.props.is_mobile}
                                         is_open={attribute.expanded || attribute.is_open}
                                         nested_entity_handler={edit_form_context.nested_entity_handler}
                                         nested_list_entities={nested_list_entities}
                                         on_change={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                         parent_entity_array={entity_instances}
                                         parent_entity_field_attribute={attribute}
                                         parent_react_entity={edit_form_context}
                                         read_only={attribute_is_read_only}
                                         set_open_state={edit_form_context.set_open_state.bind(edit_form_context, attribute)} />
            );
        }
        omit_caption = true;
    }
    else if (String(attribute.same_row).match(/^entity_record_fields_\d$/)) { //create the entity record field element.
        attribute_value = get_json_data_using_field_paths(attribute.local_field_path || attribute.field_path, entity_instance);

        if (attribute_value && attribute_value.caption) {
            attribute_value = attribute_value ? attribute_value.caption : '';
        }

        input_element = function () {
            var field = "";

            if ( edit_form_context.state.is_new_instance != true ) {
                if (attribute.db_type =="user") {
                    style = {
                        "marginLeft": "20px",
                        "color": "#898989",
                        "fontSize": "11px"
                    };

                    field = <span key={attribute_key_name} style={style}>{attribute.caption} {attribute_value}</span>;
                }
                else {
                    style = {
                        "paddingLeft": "4px",
                        "color": "#898989",
                        "fontSize": "11px"
                    };

                    field = <span key={attribute_key_name} style={style}>{(moment(attribute_value).format("M/D/Y h:mm a"))} </span>;
                }
            }

            return field;
        }();
    }
    else if (attribute.entity_reference_variant) {
        attribute_value = get_json_data_using_field_paths(attribute.local_field_path || attribute.field_path, entity_instance);

        if (attribute_value) {
            attribute_value = attribute_value.entity_id;
        }

        input_element = (
            <RefLookupContainerComponent
                attribute={attribute}
                attribute_is_read_only={attribute_is_read_only}
                attribute_key_name={attribute_key_name}
                attribute_value={attribute_value}
                edit_form_context={edit_form_context}
                entity_instance={entity_instance}
                nested_entity_name={nested_entity_name}
                set_next_focus_element_function={set_next_focus_element_function}
            />
        );
    }
    else if (attribute.entity_reference && attribute.entity_reference.is_list) {
        var temp_nested_reference_entity_data = {
            reference_entity_name: attribute.entity_reference.reference_collection,
            attribute: attribute,
            new_entity_json: attribute.entity_reference.new_entity_json
        };

        var data_list_key = attribute.field_path;
        if (attribute.last_react_key) {
            data_list_key = attribute.last_react_key;
        }
        else if(use_cached_attributes) {
            attribute.last_react_key = data_list_key + general_utils.create_guid();
            data_list_key = attribute.last_react_key;
        }

        var handle_add_func = null;
        var handle_delete_func = null;
        var grid_init_callback = null;
        if (attribute.entity_reference.use_field_as_data_source) {
            handle_delete_func = function(grid, row_id_arr, row_index_arr, callback) {
                var local_did_change = false;
                var local_entity_array = attribute_value || [];
                for(var i = 0; i < row_id_arr.length; i++) {
                    var entity_id_index = local_entity_array.indexOf(row_id_arr[i]);
                    if (entity_id_index != -1) {
                        local_did_change = true;
                        local_entity_array.splice(entity_id_index, 1);
                    }
                }
                if (local_did_change) {
                    if (grid && row_index_arr) {
                        for (var i = 0; i < row_index_arr.length; i++) {
                            grid.deleteRow(row_index_arr[i]);
                        }
                    }

                    edit_form_context.on_field_change.call(edit_form_context, attribute, attribute_value);
                }
                return callback();
            };
            grid_init_callback = function(reference_lookup_grid, requestAndSetCount) {
                attribute.update_grid = function() {
                    if (requestAndSetCount) {
                        requestAndSetCount(null, function() {
                            attribute.cached_rendered_component = null; //force re-render since value changed
                            attribute.last_react_key = attribute.field_path + general_utils.create_guid();
                            attribute.modified = true;
                            edit_form_context.forceUpdate(function(){attribute.last_react_key=null;});
                        });
                    }
                    if (reference_lookup_grid) {
                        reference_lookup_grid.refresh();
                    }
                };
            }
        }

        input_element = (
            <ReferenceLookupDataListComponent
                key={data_list_key}
                app_object_code={attribute.entity_reference.reference_collection + "_default_data_list"}
                app_object_conditions={((attribute.entity_reference.use_field_as_data_source) ? {_id: {$in: attribute_value || []}} : (attribute.entity_reference.conditions || {}))}
                app_object_handler={edit_form_context.props.app_object_handler}
                disable_create={attribute.entity_reference.disable_create}
                disallow_grid_filters={attribute.entity_reference.disallow_grid_filters}
                disallow_grid_workflows={attribute.entity_reference.disallow_grid_workflows}
                grid_init_callback={grid_init_callback}
                handle_add={handle_add_func}
                handle_delete={handle_delete_func}
                handle_executing={edit_form_context.props.handle_executing}
                is_mobile={edit_form_context.props.is_mobile}
                is_open={attribute.expanded || attribute.is_open}
                logged_in_false={edit_form_context.props.logged_in_false}
                nested_entity_handler={edit_form_context.nested_entity_handler}
                nested_reference_entity_data={temp_nested_reference_entity_data}
                new_entity_json={attribute.entity_reference.new_entity_json}
                parent_react_entity={edit_form_context}
                record_count={(attribute.entity_reference.use_field_as_data_source) ? (attribute_value || []).length : attribute.entity_reference.record_count}
                set_open_state={edit_form_context.set_open_state.bind(edit_form_context, attribute)}
            />
        );
    }
    else if (attribute.is_nested_entity && !attribute.data_is_nested) {
        if (attribute.is_array) {
            if (!attribute_value) {
                entity_instance[attribute.local_field_path || attribute.field_path] = [];
                attribute_value = entity_instance[attribute.local_field_path || attribute.field_path];
            }
            if (attribute.select_options || attribute.lookup) {
                if (hasCreateAccess) { //add a + sign.
                    input_element = function () {
                        var add_func = function () {
                            edit_form_context.setState({ checkbox_fileupload : false, currentAttribute:attribute});
                            edit_form_context.reference_entity_handler(attribute, null, null);
                        };
                        var addButton = '';
                        if (!(attribute_is_read_only)) {
                            addButton = <button type="button"
                                                className="edit-controls-add-button dx-button"
                                                onClick={add_func.bind( edit_form_context )}
                                                style={{right : "12px", cursor:"pointer"}}
                                                tabIndex={-1}>
                                <div className='dx-button-content'>
                                    <i className='dx-icon dx-icon-edit-button-addrow'>

                                    </i>
                                </div>
                            </button>;
                        }
                        // TODO: refactoring this when save operation will return object
                        if (attribute.db_type == "file") {
                            if (!edit_form_context.state.privateFiles) {
                                edit_form_context.state.privateFiles = {};
                            }
                            if (!edit_form_context.state.privateFiles[attribute.field_path]) {
                                edit_form_context.state.privateFiles[attribute.field_path] = [];
                            }
                            if (entity_instance[attribute.field_path]) {
                                for (var k = 0; k < entity_instance[attribute.field_path].length; k++) {
                                    var exists = false;
                                    for (var p = 0; p < edit_form_context.state.privateFiles[attribute.field_path].length; p++) {
                                        if(entity_instance[attribute.field_path][k] == undefined)
                                        {
                                            delete entity_instance[attribute.field_path][k];
                                            exists = true;
                                            break;
                                        }
                                        else if(entity_instance[attribute.field_path][k]==edit_form_context.state.privateFiles[attribute.field_path][p])
                                        {
                                            exists = true;
                                            break;
                                        }
                                        else if(edit_form_context.state.privateFiles[attribute.field_path][p] == undefined)
                                        {   delete edit_form_context.state.privateFiles[attribute.field_path][p];
                                            exists = true;
                                            break;
                                        }
                                        else if(entity_instance[attribute.field_path][k].entity_id==edit_form_context.state.privateFiles[attribute.field_path][p].entity_id)
                                        {
                                            exists = true;
                                            break;
                                        }
                                        else if(entity_instance[attribute.field_path][k].entity_id == edit_form_context.state.privateFiles[attribute.field_path][p])
                                        {
                                            exists = true;
                                            break;
                                        }


                                        else if(entity_instance[attribute.field_path][k]==edit_form_context.state.privateFiles[attribute.field_path][p].entity_id)
                                        {
                                            exists = true;
                                            break;
                                        }

                                    }
                                    if (!exists) {
                                        edit_form_context.state.privateFiles[attribute.field_path].push(entity_instance[attribute.field_path][k]);
                                    }
                                    var existsindex =null;
                                    var elementPos = entity_instance[attribute.field_path].map(function(x) {return x; }).indexOf(entity_instance[attribute.field_path][k].entity_id);
                                    if (elementPos != -1)
                                    {
                                        existsindex = elementPos;
                                    }
                                    if (existsindex != null) {
                                        entity_instance[attribute.field_path].splice(existsindex, 1);
                                    }

                                }
                                if (!attribute.select_options){
                                    attribute.select_options = [];
                                }

                                for (p = 0; p < edit_form_context.state.privateFiles[attribute.field_path].length; p++) {
                                    exists = false;
                                    for (k = 0; k < attribute.select_options.length; k++) {
                                        if(edit_form_context.state.privateFiles[attribute.field_path][p] == undefined)
                                        {
                                            delete edit_form_context.state.privateFiles[attribute.field_path][p];
                                            exists = true;
                                            break;
                                        }
                                        else if(attribute.select_options[k] && attribute.select_options[k].entity_id == edit_form_context.state.privateFiles[attribute.field_path][p].entity_id)
                                        {
                                            attribute.select_options[k] = edit_form_context.state.privateFiles[attribute.field_path][p];
                                            exists = true;
                                            break;
                                        } else if (!attribute.select_options[k]) {
                                            delete attribute.select_options[k];
                                        }
                                    }
                                    if (!exists) {
                                        attribute.select_options.push(edit_form_context.state.privateFiles[attribute.field_path][p]);
                                    }
                                }
                            }
                        }
                        var tagbox_popover ="";
                        if(edit_form_context.state.tag_template){
                            if(edit_form_context.state.tag_template_values) {
                                tagbox_popover ="";
                                var tag_values = edit_form_context.state.tag_template_values;
                                var id_tag = (attribute.safe_field_path || attribute.field_path) + '_' + tag_values._id;
                                var icon = "";
                                if (tag_values.entity == "file") {
                                    if(tag_values.hidden_fa_icon !== null) {
                                        icon = <i
                                            style={{"color":"#606060","fontSize" : "40px" ,"marginLeft" : "-15px", "marginTop" : "20px"}}
                                            className={"fa "+tag_values.hidden_fa_icon}
                                            aria-hidden="true">&nbsp;</i>;
                                    }
                                    else{
                                        icon = <i
                                            style={{"color":"#606060","fontSize" : "40px" ,"marginLeft" : "-15px", "marginTop" : "20px"}}
                                            className={"fa "+tag_values.static_icon}
                                            aria-hidden="true">&nbsp;</i>;
                                    }

                                    var description_array = [];

                                    if(tag_values.description) {
                                        var div = <div
                                            key={"tag_"+ "description"}
                                            style={{"fontSize":"11px", "marginTop": "5px"}}>
                                            {tag_values.description}
                                        </div>;
                                        description_array.push(div);
                                    }

                                    if(tag_values.file_name) {
                                        var div = <div
                                            key={"tag_"+ "file_name"}
                                            style={{"fontSize":"11px", "marginTop": "5px"}}>
                                            {tag_values.file_name}
                                        </div>;
                                        description_array.push(div);
                                    }

                                    if(tag_values.author) {
                                        var div = <div key={"tag_"+ "author"} style={{"fontSize":"11px", "marginTop": "5px"}}>
                                            {tag_values.author.caption}
                                        </div>;
                                        description_array.push(div);
                                    }

                                    if(tag_values.date_uploaded) {
                                        var tag_date = new Date(tag_values.date_uploaded);
                                        var addZero = function(i) {
                                            if (i < 10) {
                                                i = "0" + i;
                                            }
                                            return i;
                                        };

                                        var formatted_date = (tag_date.getMonth() + 1) + '/' + tag_date.getDate() + '/' +  tag_date.getFullYear() + '    ' + addZero(tag_date.getHours()) + ':' + addZero(tag_date.getMinutes());
                                        var div = <div key={"tag_"+ "date_uploaded"} style={{"fontSize":"11px", "marginTop": "5px"}}>
                                            {formatted_date}
                                        </div>;
                                        description_array.push(div);
                                    }
                                    else if(tag_values.date_created =="date_created" && !tag_values.date_uploaded)
                                    {
                                        var tag_date = new Date(tag_values.date_created);
                                        var addZero = function(i) {
                                            if (i < 10) {
                                                i = "0" + i;
                                            }
                                            return i;
                                        };

                                        var formatted_date = (tag_date.getMonth() + 1) + '/' + tag_date.getDate() + '/' +  tag_date.getFullYear() + '    ' + addZero(tag_date.getHours()) + ':' + addZero(tag_date.getMinutes());
                                        var div = <div key={"tag_"+ "date_created"} style={{"fontSize":"11px", "marginTop": "5px"}}>
                                            {formatted_date}
                                        </div>;
                                        description_array.push(div);
                                    }


                                    tagbox_popover = <div style={{"position":"absolute","left":"-9999px","visibility":"hidden"}}><div className="col-xs-12" id={"id"+id_tag}>
                                        <div className="col-xs-1">
                                            {icon}
                                        </div>
                                        <div className="col-xs-9">
                                            {description_array}
                                        </div>
                                        <div style={{"marginTop": "5px","fontSize" : "15px"}}
                                             className="col-xs-1">
                                            <a style={{"color":"#606060","cursor": "pointer"}} id={"edit_"+id_tag}><i className="fa fa-pencil-square-o" aria-hidden="true">&nbsp;</i></a>
                                            <a style={{"color":"#606060","cursor": "pointer"}} id={"download_"+id_tag}><i style={{"marginTop":"5px"}} className="fa fa-download" aria-hidden="true">&nbsp;</i></a>
                                            <a style={{"color":"#606060","cursor": "pointer"}} id={"delete_"+id_tag} ><i style={{"marginTop":"5px"}} className="fa fa-trash" aria-hidden="true">&nbsp;</i></a>
                                        </div>

                                    </div></div>;
                                }
                            }
                        }
                        var usetagtemplate = false;
                        if(edit_form_context.state.new_filelist_data != undefined && attribute.db_type == "file"){
                            attribute.select_options = edit_form_context.state.new_filelist_data.filter(function(a) { //somehow this gets non-object values in it
                                return a.entity_id;
                            });
                        }
                        if(attribute.db_type =="file")
                        {
                            usetagtemplate = true;
                        }
                        if(attribute.lookup && !attribute.dataSource) {
                            edit_form_context.lookup_load(attribute);
                        }
                        return (
                            <div style={{  marginRight : "-40.5px"   } }
                                 id={attribute.safe_field_path || attribute.field_path}
                                 data-attribute={JSON.stringify(attribute)}
                                 key={attribute_key_name}>
                                <EditorDevExtremeTagBox
                                    tagbox_holder={attribute}
                                    dataSource={attribute.dataSource}
                                    displayExpr="caption"
                                    valueExpr="entity_id"
                                    usetagtemplate = {usetagtemplate}
                                    tagTemplate={edit_form_context.tagTemplate.bind(edit_form_context, attribute)}
                                    values={get_json_data_using_field_paths(attribute.local_field_path || attribute.field_path, entity_instance)}
                                    onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                    add_button={addButton!=''}
                                    onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                    readOnly={attribute_is_read_only}
                                    set_element_reference={edit_form_context.set_element_reference.bind(edit_form_context, attribute)}
                                    skip_will_mount_phase={use_cached_attributes}
                                />
                                {addButton}
                                {tagbox_popover}
                            </div>
                        )
                    }();
                }
                else {
                    if(attribute.lookup && !attribute.dataSource) {
                        edit_form_context.lookup_load(attribute);
                    }
                    input_element =
                        <EditorDevExtremeTagBox key={attribute_key_name}
                                                tagbox_holder={attribute}
                                                dataSource={attribute.dataSource}
                                                displayExpr="caption"
                                                valueExpr="entity_id"
                                                tagTemplate={edit_form_context.tagTemplate.bind(edit_form_context, attribute)}
                                                values={attribute_value}
                                                onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                                skip_will_mount_phase={use_cached_attributes}
                                                readOnly={attribute_is_read_only}/>;
                }
            }
            else {
                return;
            }
        } else {
            attribute_value = get_json_data_using_field_paths(attribute.local_field_path || attribute.field_path, entity_instance);

            if (!attribute.select_options) {
                attribute.select_options = [];
                if(attribute_value) {
                    attribute.select_options.push(attribute_value);
                }
            }

            if (attribute_value) {
                attribute_value = attribute_value.entity_id;
            }

            input_element = function () {
                var addButton = '';
                var editButton = '';

                if (hasCreateAccess) { //add a + sign.
                    var add_func = function () {
                        //Create State variables when clicked in Plus button
                        var currentFieldPath = attribute.field_path;
                        var currentAttribute = attribute;
                        edit_form_context.setState({
                            flagSaveDropdown: 1,
                            currentFieldPath: currentFieldPath,
                            currentAttribute: currentAttribute
                        });

                        edit_form_context.reference_entity_handler(attribute, null, null);
                    };
                    var edit_func = function (e) {
                        var current_field_value = get_json_data_using_field_paths(attribute.local_field_path || attribute.field_path, entity_instance);
                        if (current_field_value == null) {
                            e.preventDefault();
                        } else {
                            current_field_value = current_field_value.entity_id || current_field_value;
                            edit_form_context.edit_fun(attribute, current_field_value);
                        }
                    };

                    if (!attribute_is_read_only
                        && !(edit_form_context.state
                        && edit_form_context.state.parent_entity_field_attribute
                        && edit_form_context.state.parent_entity_field_attribute.custom_properties.disable_create_button)
                        && !is_user_attribute) {
                        addButton =
                            <button type="button"
                                    className="x2 edit-controls-add-button add-button dx-button"
                                    onClick={add_func.bind( edit_form_context )}
                                    tabIndex={-1}
                            >
                                <div className='dx-button-content'>
                                    <i className='dx-icon dx-icon-edit-button-addrow fa fa-pencil-square-o'></i>
                                </div>
                            </button>
                        ;
                    }

                    if (hasCreateAccess
                        && !is_user_attribute) {
                        editButton =
                            <button style={{zIndex : "100"}}
                                    type="button"
                                    onClick={edit_func.bind( edit_form_context )}
                                    className="edit-controls-edit-button edit-button dx-button"
                                    tabIndex={-1}
                            >
                                <div className='dx-button-content'>
                                    <i className='dx-icon dx-icon-edit-button-addrow fa fa-pencil-square-o'></i>
                                </div>
                            </button>
                        ;
                    }
                }
                if ((attribute.field_path == "assigned_to_user") && (attribute.same_row == "assigned_to_fields")) {

                    var option_array = attribute.select_options;
                    //verify if selectbox not have default values
                    //91221083
                    var options = [],
                        emptyValue = true,
                        lov = $.parseJSON('{"code": null, "value": ""}');
                    option = <option empty_value={emptyValue} key={lov.entity_id+"_"+attribute_key_name}
                                     value={lov.entity_id}>{lov.caption}</option>;
                    options.push(option);

                    for (var j = 0, l = option_array.length; j <= l; j++) {
                        var option;
                        lov = option_array[j];
                        if (!lov) {
                            continue;
                        }
                        option = <option empty_value={emptyValue} key={lov.entity_id+"_"+attribute_key_name}
                                         value={lov.entity_id}>{lov.caption}</option>;
                        options.push(option);
                    }
                    return (
                        <div style={{"position":"absolute","top":"0px","left":"-9999px","visibility":"hidden"}}>
                            <div className="col-xs-12" id={"id"+ (attribute.safe_field_path || attribute.field_path)}>
                                <div style={{"textAlign":"center","marginBottom":"10px"}}>
                                    {R.assign_to_dialog ? R.assign_to_dialog : "Select User to Assign"}
                                </div>
                                <div className="form-group">
                                    <select id="assign-to-user-select" data-empty-value={emptyValue}
                                            className="form-control"
                                            key={"select_" + attribute_key_name}
                                            onChange={edit_form_context.on_field_both.bind(edit_form_context, attribute)}
                                            defaultValue={attribute_value}
                                    >
                                        {options}
                                    </select>
                                </div>
                            </div>
                        </div>
                    );
                }
                else {
                    if (attribute.lookup) {
                        if (!attribute.did_init_lookup && !attribute.dataSource) {
                            attribute.did_init_lookup = true;
                            edit_form_context.lookup_load(attribute);
                        }

                        return (
                            <div key={attribute_key_name} className='ref_lookup_container'>
                                <EditorDevExtremeLookup
                                    dataSource={attribute.dataSource}
                                    displayExpr="caption"
                                    valueExpr="entity_id"
                                    id={attribute.safe_field_path}
                                    value={attribute_value|| null }
                                    skip_prop_update_function={(nested_entity_name && (nested_entity_name != ""))}
                                    set_next_focus_element={set_next_focus_element_function}
                                    onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                    onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                    add_button={addButton!=''}
                                    edit_button={editButton!=''}
                                    readOnly={attribute_is_read_only}
                                    placeholder={R.start_typing_to_search?R.start_typing_to_search:'Start typing to search...'}
                                />
                                {addButton}
                                {editButton}
                            </div>);
                    }
                    else {
                        return (
                            <div key={attribute_key_name}>
                                <EditorDevExtremeSelectBox
                                    dataSource={ attribute.select_options }
                                    displayExpr="caption"
                                    valueExpr="entity_id"
                                    value={attribute_value||''}
                                    onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                    onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                    EditorDevExtremeTagBox={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                    add_button={addButton!=''}
                                    edit_button={editButton!=''}
                                    skip_will_mount_phase={use_cached_attributes}
                                    readOnly={attribute_is_read_only}/>
                                {addButton}
                                {editButton}
                            </div>);
                    }
                }
            }();
        }
    }
    else if (attribute.list_of_values) {
        var list_of_values = attribute.list_of_values;
        if (attribute.is_array) {
            if(attribute.lov_multiselect || attribute.field_path == "roles") {
                var options = [];
                for (var j = 0; j < list_of_values.length; j++) {
                    var lov = list_of_values[j];
                    var option = <option key={lov.code} data-html="true" value={lov.code}>{lov.value}&lt;div  class=&quot;hidedescription&quot;&gt;{$.trim(lov.description)} &lt;/div&gt;

                    </option>;

                    options.push(option);
                }
                input_element =
                    <div data-html="true" className="rolescls">
                        <select id={attribute.safe_field_path || attribute.field_path}
                                data-attribute={JSON.stringify(attribute)}
                                multiple="multiple"
                                className="form-control rolesmultiple"
                                defaultValue={attribute_value}
                                key={attribute_key_name}
                                readOnly={attribute_is_read_only}
                                disabled={attribute_is_read_only}
                                onChange={edit_form_context.on_field_both.bind(edit_form_context, attribute)}>
                            {options}
                        </select></div>;
            }
            else{
                input_element =
                    <EditorDevExtremeTagBox dataSource={list_of_values}
                                            displayExpr="value"
                                            valueExpr="code"
                                            tagTemplate={edit_form_context.tagTemplate.bind(edit_form_context, attribute)}
                                            values={attribute_value}
                                            key={attribute_key_name}
                                            onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                            onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                            skip_will_mount_phase={use_cached_attributes}
                                            readOnly={attribute_is_read_only}/>;
            }

        }
        else {
            if (attribute.lookup) {
                var lookup_datasource = attribute.select_options;
                if (!attribute.did_init_lookup && !attribute.dataSource) {
                    attribute.did_init_lookup = true;
                    lookup_datasource = edit_form_context.lookup_load(attribute);
                    edit_form_context.init_lookup(attribute);
                }
                input_element =   <div key={attribute_key_name} className='ref_lookup_container'>
                    <EditorDevExtremeLookup
                        dataSource={attribute.dataSource}
                        displayExpr="value"
                        valueExpr="code"
                        id={attribute.safe_field_path}
                        value={attribute_value||''}
                        set_next_focus_element={set_next_focus_element_function}
                        skip_prop_update_function={(nested_entity_name && (nested_entity_name != ""))}
                        onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                        onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                        add_button={false}
                        edit_button={false}
                        readOnly={attribute_is_read_only}
                        placeholder={R.start_typing_to_search?R.start_typing_to_search:'Start typing to search...'}
                    />
                </div>;
            }
            else{
                //verify if selectbox not have default values
                //91221083
                var options = [];
                var emptyValue = false;
                var init_option_is_placeholder = (!attribute.was_clicked_once && edit_form_context.state.is_new_instance && use_cached_attributes && attribute.html_template_placeholder_text);
                var initoption;
                var lov = {code: null, value: ""};
                if(init_option_is_placeholder || attribute.required) {
                    initoption = <option disabled selected key={(lov.code===undefined?j:lov.code)+"_"+attribute_key_name}
                                         value={lov.code}>{((edit_form_context.state.is_new_instance && use_cached_attributes && attribute.html_template_placeholder_text) ? attribute.html_template_placeholder_text : lov.value)}</option>;
                    options.push(initoption);
                }
                else if(!attribute.required){
                    emptyValue = true;
                    initoption = <option empty_value={emptyValue} key={(lov.code===undefined?j:lov.code)+"_"+attribute_key_name}
                                         value={lov.code}>{lov.value}</option>;
                    options.push(initoption);
                }

                var allowed_options_filter = function(local_lov_code) {
                    return true;
                };
                if(attribute.enum_dependant_on) {
                    //var other_attribute = entity_attributes.field_paths[attribute.enum_dependant_on];
                    var other_attribute_value = entity_instance[attribute.enum_dependant_on];
                    if(!other_attribute_value) {
                        allowed_options_filter = function(a) {return false;}
                    }
                    else {
                        other_attribute_value = other_attribute_value + "__";
                        allowed_options_filter = function(local_lov_code) {
                            return (local_lov_code && (local_lov_code.indexOf(other_attribute_value) != -1));
                        }
                    }
                }

                for (var j = 0; j < list_of_values.length; j++) {
                    var option;
                    var lov = list_of_values[j];
                    if(lov && allowed_options_filter(lov.code)) {
                        option = <option empty_value={emptyValue}
                                         key={(lov.code === undefined ? j : lov.code) + "_" + attribute_key_name}
                                         value={lov.code}>
                                     {lov.value}
                                 </option>;

                        options.push(option);
                    }
                }

                input_element =
                    <select data-empty-value={emptyValue} data-attribute_value={attribute_value}
                            className="form-control"
                            value={attribute_value || ""}
                            key={attribute_key_name}
                            readOnly={attribute_is_read_only}
                            disabled={attribute_is_read_only}
                            onKeyDown={edit_form_context.on_field_key_down.bind(edit_form_context, attribute)}
                            onMouseDown={edit_form_context.on_field_mouse_down.bind(edit_form_context, attribute)}
                            onClick={edit_form_context.on_field_click.bind(edit_form_context, attribute)}
                            onChange={edit_form_context.on_field_both.bind(edit_form_context, attribute)}
                            onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}>
                        {options}
                    </select>;
            }
        }
    }
    else if(attribute.autocomplete && !(edit_form_context.state.entity_attributes && (edit_form_context.state.entity_attributes.entity == attribute.autocomplete_entity_name))) { //don't autocomplete on your own entity
        attribute_value = get_json_data_using_field_paths(attribute.local_field_path || attribute.field_path, entity_instance);
        var autocomplete_datasource = edit_form_context.autocomplete_load(attribute);

        input_element = (
            <div key={attribute_key_name}>
                <EditorDevExtremeAutoComplete
                    dataSource={autocomplete_datasource}
                    displayExpr="entity_id"
                    valueExpr="entity_id"
                    value={attribute_value}
                    set_next_focus_element={set_next_focus_element_function}
                    onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                    onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                    readOnly={attribute_is_read_only}
                    id={attribute.safe_field_path}
                    set_fields={function (autocomplete_values) {
                        if (!autocomplete_values) {
                            return;
                        }
                        var partial_field_path = attribute.field_path; //This field represents the key, which we assume to be a top-level field on the (directly nested) entity
                        if (!partial_field_path || (partial_field_path.indexOf(":") == -1)) {
                            return;
                        }
                        partial_field_path = partial_field_path.substring(0, partial_field_path.lastIndexOf(":") + 1);
                        var field_path_attributes = edit_form_context.state.entity_attributes.field_paths;
                        var invalidate_html_template_cache = false, modified_value_count = 0;
                        for (var autocomplete_field_name in autocomplete_values) {
                            if (autocomplete_values.hasOwnProperty(autocomplete_field_name)) {
                                var entity_attribute_from_field_path = field_path_attributes[partial_field_path + autocomplete_field_name];
                                if (entity_attribute_from_field_path) {
                                    modified_value_count++;
                                    invalidate_html_template_cache = set_json_data_using_field_paths(partial_field_path + autocomplete_field_name, edit_form_context.state.update_fields, autocomplete_values[autocomplete_field_name], true) || invalidate_html_template_cache;
                                    entity_instance[partial_field_path + autocomplete_field_name] = autocomplete_values[autocomplete_field_name]; //fill in autocomplete fields for this entity if these fields exist
                                    entity_attribute_from_field_path.cached_rendered_component = null;
                                    entity_attribute_from_field_path.last_react_key = null;
                                }
                            }
                        }

                        if (modified_value_count) {
                            if (invalidate_html_template_cache) {
                                edit_form_context.state.entity_attributes.cached_custom_html_args = null;
                            }
                            edit_form_context.forceUpdate();
                        }
                    }}
                />
            </div>);
    }
    else {
        var type = attribute.attribute_type == null ? attribute.db_type : attribute.attribute_type,
            style={};
        switch (type) {
            case "Image":
                var resizeWidth = null;
                var resizeHeight = null;
                if (attribute.custom_properties) {
                    if (attribute.custom_properties.max_height && attribute.custom_properties.max_width) {
                        resizeWidth = attribute.custom_properties.max_width;
                        resizeHeight = attribute.custom_properties.max_height;
                    }
                }
                input_element =
                    <EditorDevExtremeImageUpload onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                 value={attribute_value}
                                                 readOnly={attribute_is_read_only}
                                                 resizeWidth={resizeWidth}
                                                 resizeHeight={resizeHeight}
                                                 key={attribute_key_name}
                                                 onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                                 selectButtonText={R.select_image}/>;
                break;
            case "File":
                if(!edit_form_context.state.file_uploaded && !entity_instance["file_name"]) {
                    input_element = <div >
                        <button type="button"
                                className="btn-gd btn btn-default"
                                onClick={edit_form_context.google_drive_api.bind(edit_form_context, attribute)}
                                checked={attribute_value}
                                readOnly={attribute_is_read_only}
                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                disabled={attribute_is_read_only}><img
                            style={{"height" : "20px", "marginRight": "5px"}}
                            src="./assets/img/Logo_of_Google_Drive.png"/>{R.choose_from_drive}</button>
                        <EditorFileUpload
                            onFileNameChange={edit_form_context.on_file_name_change.bind(edit_form_context, attribute)}
                            onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                            fileName={entity_instance['file_name']}
                            value={entity_instance._id}
                            isNewInstance={edit_form_context.state.is_new_instance}
                            resetFileUpload={edit_form_context.state.resetFileUpload}
                            key={attribute_key_name}
                            uploadFiles_array={ edit_form_context.uploadFiles_array }
                            readOnly={attribute_is_read_only}/></div>;
                }
                else if(edit_form_context.state.file_uploaded){
                    input_element = <div style={{"textDecoration ": "underline","paddingTop": "7px"}}
                                         key={attribute_key_name}
                                         onClick={edit_form_context.remove_file.bind(edit_form_context, attribute)}
                    >
                        <i className="fa fa-times" aria-hidden="true">&nbsp;</i> {R.cs_remove_file || "Remove"}
                    </div>;
                }
                else{
                    var downloadUrl = null;
                    if(edit_form_context.props._id) {
                        if(!edit_form_context.state.downloadUrl && !edit_form_context.downloadFlag  ){
                            downloadUrl = edit_form_context.download_file(edit_form_context.props._id);
                            if(downloadUrl){ edit_form_context.downloadFlag = false;}
                        }
                    }
                    downloadUrl = downloadUrl || edit_form_context.state.downloadUrl;
                    input_element = [];

                    var removebutton = <div style={{"textDecoration ": "underline","paddingTop": "7px"}}
                                            key={attribute_key_name}
                                            onClick={edit_form_context.remove_file.bind(edit_form_context, attribute)}
                    >
                        <i className="fa fa-times" aria-hidden="true">&nbsp;</i> {R.cs_remove_file || "Remove"}
                    </div>;
                    var download_button;
                    if(!edit_form_context.downloadFlag){


                        download_button = <a
                            key={attribute_key_name+"download"}
                            href={downloadUrl}
                        >
                            <i className="fa fa-download" aria-hidden="true">&nbsp;</i> {R.download}
                        </a>;
                    }else{
                    }
                    input_element.push(removebutton);
                }
                break;
            case "Html":
                input_element =
                    <EditorHtml onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                key={attribute_key_name}
                                value={attribute_value||''}
                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                readOnly={attribute_is_read_only}/>;
                break;
            case "YesNo":
                if(attribute.required || attribute.read_only )
                {
                    input_element =
                        <EditorDevExtremeSwitchYesNo onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                     key={attribute_key_name}
                                                     value={attribute_value}
                                                     onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                                     readOnly={attribute_is_read_only}/>;
                }
                else{
                    id = attribute.caption.replace(/ /g,'');
                    input_element = <div id={id} key={attribute_key_name}>
                        <button id={id+"1"}
                                type="button"
                                className="btn btn-primary"
                                onClick={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                checked={attribute_value}
                                readOnly={attribute_is_read_only}
                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                disabled={attribute_is_read_only}>Yes</button>
                        <button id={id+"2"}
                                type="button"
                                className="btn btn-primary"
                                onClick={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                checked={attribute_value}
                                readOnly={attribute_is_read_only}
                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                disabled={attribute_is_read_only}>No</button>
                        <button id={id+"3"}
                                type="button"
                                className="btn btn-primary"
                                onClick={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                checked={attribute_value}
                                readOnly={attribute_is_read_only}
                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                disabled={attribute_is_read_only}>N/A</button>
                    </div>;
                }
                break;
            case "Boolean":
                if (attribute.required || attribute.read_only) {
                    input_element = <div><label>
                        <input className="form-control checkbox-slider colored-blue"
                               type="checkbox"
                               key={attribute_key_name}
                               onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                               checked={attribute_value}
                               readOnly={attribute_is_read_only}
                               onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                               disabled={attribute_is_read_only}/>
                        <span className="text">&nbsp;</span>
                    </label></div>;
                }
                else {
                    var id = attribute.caption;
                    id = id.replace(/ /g, '');
                    input_element = <div id={id} key={attribute_key_name}>
                        <button id={id+"1"}
                                type="button"
                                className="btn btn-primary"
                                onClick={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                checked={attribute_value}
                                readOnly={attribute_is_read_only}
                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                disabled={attribute_is_read_only}>True
                        </button>
                        <button id={id+"2"}
                                type="button"
                                className="btn btn-primary"
                                onClick={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                checked={attribute_value}
                                readOnly={attribute_is_read_only}
                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                disabled={attribute_is_read_only}>False
                        </button>
                        <button id={id+"3"}
                                type="button"
                                className="btn btn-primary"
                                onClick={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                checked={attribute_value}
                                readOnly={attribute_is_read_only}
                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                disabled={attribute_is_read_only}>N/A
                        </button>
                    </div>;
                }

                break;
            case "CheckBox":
                input_element =
                    <input className=" form-checkbox" type="checkbox"
                           onClick={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                           onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                           key={attribute_key_name}
                           checked={attribute_value}
                           value={attribute_value}
                           readOnly={attribute_is_read_only}
                           disabled={attribute_is_read_only}/>;

                break;
            case "MaskedTextBox":
                var mask_data = attribute.mask_data || {};
                var mask_rules = mask_data.mask_rules;
                if (mask_rules) {
                    for (var field_name in mask_rules) {
                        mask_rules[field_name] = try_parse_regexp(mask_rules[field_name]);
                    }
                }
                if(attribute_value == null)
                {
                    attribute_value ="";
                }
                input_element =
                    <EditorDevExtremeMaskedTextBox onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                   key={attribute_key_name}
                                                   value={attribute_value||''}
                                                   readOnly={attribute_is_read_only}
                                                   mask={mask_data.mask}
                                                   maskRules={mask_rules}
                                                   maskChar={mask_data.mask_char || "_"}
                                                   useMaskedValue={mask_data.use_masked_value}
                                                   onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                                   rtlEnabled={attribute.right_to_left || false}/>;
                break;
            case "Recurrent":
                input_element =
                    <div key={attribute_key_name}>
                        <EditorRecurrenceInput onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                               value={attribute_value}
                                               readOnly={attribute_is_read_only}
                                               onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                        />
                    </div>;
                break;
            case "MultiLineTextBox":
                var height = undefined;
                if (attribute.custom_properties && attribute.custom_properties.lines_displayed) {
                    // http://stackoverflow.com/questions/2034544/textareas-rows-and-cols-attribute-in-css
                    height = (1 + parseFloat(attribute.custom_properties.lines_displayed) * 1.42857).toString() + 'em';
                }
                input_element =
                    <EditorDevExtremeMultiLineTextBox onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                      value={attribute_value}
                                                      height={height}
                                                      readOnly={attribute_is_read_only}
                                                      key={attribute_key_name}
                                                      onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                    />;
                break;
            case "Date":
                input_element =
                    <EditorDevExtremeDatePicker onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                key={attribute_key_name}
                                                is_mobile={edit_form_context.props.is_mobile}
                                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                                value={attribute_value}
                                                readOnly={attribute_is_read_only}/>;
                break;
            case "DateTime":
                input_element =
                    <EditorDevExtremeDateTimePicker onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                    value={attribute_value}
                                                    is_mobile={edit_form_context.props.is_mobile}
                                                    onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                                    key={attribute_key_name}
                                                    unique_control_id={attribute_key_name}
                                                    readOnly={attribute_is_read_only}/>;
                break;
            case "DateTimeLocal":
                input_element =
                    <EditorDevExtremeDateTimePicker onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                    value={attribute_value}
                                                    is_mobile={edit_form_context.props.is_mobile}
                                                    onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                                    key={attribute_key_name}
                                                    unique_control_id={attribute_key_name}
                                                    readOnly={attribute_is_read_only}/>;
                break;
            case "Time":
                input_element =
                    <EditorDevExtremeTimePicker onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                                key={attribute_key_name}
                                                value={attribute_value}
                                                is_mobile={edit_form_context.props.is_mobile}
                                                onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                                readOnly={attribute_is_read_only}/>;
                break;
            case "Section":
                input_element = <div className="form-title form_section_title"
                                     key={"QK-section-"+attribute.caption}>{attribute.caption}</div>;
                omit_caption = true;
                if(attribute_options) {
                    attribute_options.currentSection = attribute.caption;
                }
                break;
            case "currency":
                if (attribute_caption_image) {
                    style = {
                        "backgroundImage": "url(" + attribute_caption_image + ")",
                        "backgroundRepeat": "no-repeat",
                        "backgroundSize": "34px auto",
                        "textIndent": "28px"
                    };
                }
                try{
                    attribute_value = attribute_value.toFixed(2);
                }catch(e){}
                input_element = <input type="text" className="form-control" key={attribute_key_name}
                                       value={(attribute_value == null) ? '' : attribute_value}
                                       onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                       onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                       readOnly={attribute_is_read_only}
                                       disabled={attribute_is_read_only}
                                       style={style}
                />;
                break;
            default:
                if (attribute_caption_image) {
                    style = {
                        "backgroundImage": "url(" + attribute_caption_image + ")",
                        "backgroundRepeat": "no-repeat",
                        "backgroundSize": "34px auto",
                        "textIndent": "28px"
                    };
                }
                input_element = <input id={attribute.safe_field_path}
                                       type="text"
                                       className={"form-control" + ((attribute.error) ? ' invalid' : '')}
                                       key={attribute_key_name}
                                       placeholder={(edit_form_context.state.is_new_instance && use_cached_attributes && attribute.html_template_placeholder_text) ? attribute.html_template_placeholder_text : ""}
                                       value={(attribute_value == null) ? '' : attribute_value}
                                       onBlur={edit_form_context.on_field_blur.bind(edit_form_context, attribute)}
                                       onChange={edit_form_context.on_field_change.bind(edit_form_context, attribute)}
                                       readOnly={attribute_is_read_only}
                                       disabled={attribute_is_read_only}
                                       style={style}
                />;
                break;
        }
    }
    var info_id = "info_" + (attribute.safe_field_path || attribute.field_path.replace(/:/g, '-'));
    if (((attribute.field_path=='assigned_to_user') && (attribute.same_row == "assigned_to_fields")) || !attribute_options){
        if(attribute_options) {
            attribute_options.row_array = null;
            attribute_options.row_name = null;
            attribute_options.prev_same_row = null;
        }
        if(use_cached_attributes) {
            //var info_id_desc = info_id + "_desc";
            if(!is_custom_edit_form && attribute.description && (attribute.description != attribute.field_path) && !(attribute.is_nested_entity && attribute.data_is_nested)) { //skip descriptions which are unset or for controls which contain entire entities
                attribute.cached_rendered_component = (
                    <div className={"tooltip_popup tooltip_popup_fade" + ((attribute.required && !attribute.read_only)? " requiredcls" : "")} data-title={attribute.description}>
                        {input_element}
                        <span id={info_id}> </span>
                    </div>
                );


                console.log(info_id);
                console.log(attribute.description);
            }
            else {
                attribute.cached_rendered_component = (
                    <span className={(attribute.required && !attribute.read_only)? "requiredcls" : ""}>
                        {input_element}
                        <span id={info_id}> </span>
                    </span>
                );
            }
            return attribute.cached_rendered_component;
        }
        return input_element;
    }
    else {
        var caption_label = "";
        if (!omit_caption) {
            caption_label = <label  style={{'verticalAlign': ' bottom'}} id={info_id}>{attribute.caption}</label>;
        }
        if (!same_row) {
            var ret_array = [];
            if (attribute_options && attribute_options.row_name) {
                input_div = <div  className="row"
                                  key={"QK-input-wrapper-row-name-"+attribute_options.row_name.toString()+"-"+info_id}>
                    {attribute_options.row_array}
                </div>;
                ret_array.push(input_div);
                attribute_options.row_array = null;
                attribute_options.row_name = null;
                attribute_options.prev_same_row = null;
            }

            if(attribute.required==true && attribute.read_only == false) {
                input_div = <div className="row" key={"QK-input-wrapper-"+info_id}>
                    <div className="4 col-sm-12">
                        <div className="form-group requiredcls forminput" >
                            {caption_label}
                            {input_element}
                        </div>
                    </div>
                </div>;
            }
            else{
                input_div = <div className="row" key={"QK-input-wrapper-"+info_id}>
                    <div className="3 col-sm-12">
                        <div className="form-group forminput" >
                            {caption_label}
                            {caption_label==''? <span style={{display : 'block'}}>
                                        {input_element}
                                    </span> : input_element}
                        </div>
                    </div>
                </div>;
            }
            ret_array.push(input_div);
            info_id += "_desc";
            ret_array.push(<div className="rowses" id={info_id}
                                  key={"QK-input-wrapper-info-id"+info_id}>{attribute.description}</div>);
            if(use_cached_attributes) {
                attribute.cached_rendered_component = ret_array;
            }
            return ret_array;
        }
        else {
            var ret_val;
            var rowsCount = 0;
            var modulus = 0;
            if(attribute_options) {
                if (attribute_options.prev_same_row != null && attribute_options.prev_same_row != same_row) {
                    input_div = <div className="row"
                                     key={"QK-input-wrapper-row-name-"+attribute_options.row_name.toString()+"-"+info_id}>{attribute_options.row_array}</div>;
                    if (String(attribute_options.prev_same_row).match(/^entity_record_fields_\d$/)) { //we make an exception for record fields to go to a separate object.
                        attribute_options.record_fields_box.push(input_div);
                    } else {
                        ret_val = input_div;
                    }
                    attribute_options.row_array = [];
                    attribute_options.row_name = null;
                    attribute_options.prev_same_row = null;
                }
                //same_row
                if (attribute_options.same_row_count) {
                    rowsCount = (12 / attribute_options.same_row_count | 0);
                    modulus = 12 % attribute_options.same_row_count;
                }
                if (modulus > 0) {
                    if (!edit_form_context.current_row) {
                        edit_form_context.non_string = modulus - attribute_options.type_string_row;
                        if (edit_form_context.non_string <= 0) {
                            edit_form_context.remanining_spaces_string = modulus;
                            edit_form_context.remanining_spaces_non_string = 0;

                        }
                        else {
                            edit_form_context.remanining_spaces_string = attribute_options.type_string_row;
                            edit_form_context.remanining_spaces_non_string = edit_form_context.non_string;
                        }
                        edit_form_context.current_row = attribute_options.same_row_count;
                        if (attribute.attribute_type != "String" && attribute.attribute_type != "zipcode_field" && attribute.attribute_type != "DateTime" && attribute.attribute_type != "DateTimeLocal") {
                            if (edit_form_context.remanining_spaces_non_string > 0) {
                                rowsCount++;
                                edit_form_context.remanining_spaces_non_string--;

                            }
                        }
                        else {
                            if (edit_form_context.remanining_spaces_string > 0) {
                                rowsCount++;
                                edit_form_context.remanining_spaces_string--;

                            }
                        }
                        edit_form_context.current_row--;

                    }
                    else {
                        if (attribute.attribute_type != "DateTime" && attribute.attribute_type != "DateTimeLocal" && attribute.attribute_type != "String" && attribute.attribute_type != "zipcode_field") {
                            if (edit_form_context.remanining_spaces_non_string > 0) {
                                rowsCount++;
                                edit_form_context.remanining_spaces_non_string--;

                            }
                        }
                        else {
                            if (edit_form_context.remanining_spaces_string > 0) {
                                rowsCount++;
                                edit_form_context.remanining_spaces_string--;

                            }
                        }
                        edit_form_context.current_row--;
                    }

                }
                attribute_options.prev_same_row = same_row;
            }
            if(rowsCount == 0) {
                rowsCount = 12
            }
            if(attribute.required==true && attribute.read_only == false) {
                input_div =
                    <div className={"a3 col-sm-" + rowsCount} key={"QK-row-array-"+info_id}>
                        <div className="form-group requiredcls forminput" >
                            <div className="pull-down"  >
                                {caption_label}
                                {input_element}
                            </div>
                        </div>
                    </div>;
            }
            else if(String(attribute.same_row).match(/^entity_record_fields_\d$/)){
                input_div = input_element;
            }
            else{
                if(type == "Section"){
                    input_div =
                        <div className={"a1 col-sm-" + rowsCount} key={"QK-row-array-"+info_id} >
                            <div className="form-group forminput" style={{position:"relative"}} >
                                {caption_label}
                                {input_element}
                            </div>
                        </div>;
                }else{
                    input_div =
                        <div className={"a2 col-sm-" + rowsCount} key={"QK-row-array-"+info_id}>
                            <div className="form-group forminput" >
                                <div className="pull-down" >
                                    {caption_label}
                                    {input_element}
                                </div>
                            </div>
                        </div>;

                }

            }
            info_id += "_desc";
            if(attribute_options) {
                attribute_options.row_array = attribute_options.row_array || [];
                attribute_options.row_array.push(input_div);
                attribute_options.row_array.push(<div className="prevent_margin" id={info_id}
                                                      key={"QK-row-array-info-id"+info_id}>{attribute.description}</div>);
            }
            else if(!ret_val) {
                ret_val = input_div;
            }
            if(use_cached_attributes) {
                attribute.cached_rendered_component = ret_val;
            }
            return ret_val;
        }
    }
}

function nested_entity_row_popup_function(context, data_row, is_new, app_object, entity_attributes, nested_list_entities, parent_entity_array, parent_entity_field_attribute, parent_react_entity, base_field_path, disable_delete) {
    context.debugLog('init_grid nested_popup_func', true);

    var constructed_app_object = {};
    constructed_app_object.code = (app_object || context.props.app_object).edit_app_object;
    constructed_app_object.type = "edit_form";
    constructed_app_object._id = data_row._id;
    constructed_app_object = $.extend({}, (app_object || context.props.app_object), constructed_app_object);

    var data = {};
    data.app_object = constructed_app_object;
    data.entity_attributes = entity_attributes || context.state.entity_attributes;
    data.nested_list_entities = nested_list_entities || context.props.nested_list_entities;
    data.workflow_states = constructed_app_object.workflow_states;
    data.entity_instance = $.extend(true, {}, data_row);
    data.parent_entity_array = parent_entity_array || context.props.parent_entity_array;
    data.parent_entity_field_attribute = parent_entity_field_attribute || context.props.parent_entity_field_attribute;
    data.parent_react_entity = parent_react_entity || context.props.parent_react_entity;
    data.is_new_instance = is_new;
    data.is_new_and_save = true;
    data.base_field_path = base_field_path;
    data.disable_delete = disable_delete;

    context.debugLog('init_grid nested_popup_func', false);
    return (context.nested_entity_handler || context.props.nested_entity_handler)(data);
}


function create_data_list_column(properties) {
    var attribute = properties.attribute;
    var column = {
        name: attribute.field_path,
        dataField: attribute.field_path,
        caption: attribute.caption,
        allowHiding:((attribute.field_path != "xenforma_status") && !attribute.entity_caption_flag),
        visible: properties.is_attribute_visible
    };

    if ( attribute.entity_caption_flag && (column.visible == false) && (column.allowHiding == false) ) {
        column.allowHiding = true; //Also will need to allow this to show up in the column chooser
    }

    if ( attribute.list_of_values ) {
        var tempAttribute = attribute.list_of_values;
        column.allowHeaderFiltering = true;
        column.headerFilter = {
            dataSource: {
                load: function (loadOptions) {
                    var res = [];
                    for ( var i = 0; i < tempAttribute.length; i++ ) {
                        res.push({text: tempAttribute[i].value, value: tempAttribute[i].code});
                    }
                    return res;
                }
            }
        }
    }
    else {
        column.allowHeaderFiltering = false;
    }

    var allow_column_edit = false;
    if ( attribute.display_as_primary_key ) { //These fields are not editable because they need to be clickable via Mobile
        column.allowEditing = false;
    }
    else if ( attribute.read_only || !attribute.grid_editable ) { //in-grid editing not allowed for read-only fields or fields not marked as grid_editable
        if (!properties.grid_is_on_edit_form) { //custom handling is in place already for these in the onEditingStart eventHandler
            column.allowEditing = false;
        }
    }
    else if ( !properties.disallow_editing && attribute.grid_editable ) {
        allow_column_edit = true;
    }

    var filter = get_parameter(column.dataField);
    if ( filter ) {
        column.filterValue = filter;
    }

    var type = attribute.attribute_type == null ? attribute.db_type : attribute.attribute_type;

    column.dataType = 'string';
    if ( (attribute.db_type == "String") && (attribute.primary_key || attribute.display_as_primary_key) ) {
        create_clickable_column_for_opening_this_entity(properties, column, type, allow_column_edit);
    }
    if ( properties.app_object && properties.app_object.entity=="xenforma_note" ) {
        column.visible = false;
    }

    column.calculateCellValue = function(rowData){
        return get_json_data_using_field_paths(column.dataField, rowData);
    };

    switch (type) {
        case "Image":{
            column.cellTemplate = function (container, options) {
                if (options.value) {
                    $("<div style='float:left;background-image:url("+options.value+");background-repeat:none;background-position:center center;width:25px;height:25px;background-size:cover;'></div>").appendTo(container);
                }
            };
            column.allowFiltering = false;
            break;
        }
        case "Recurrent":{
            column.allowFiltering = false;
            column.cellTemplate = function (container, options) {
                var value = options.value;
                if ( value && (typeof value === "string" || value instanceof String) ) {
                    if ( value.slice(0, 6) == 'RRULE:' ) {
                        value = value.substr(6);
                    }
                    try {
                        (container).html(RRule.fromString(value).toText());
                    } catch(e) {}
                }
            };
            break;
        }
        case "Html":{
            column.cellTemplate = function (container, options) {
                if (options.value && options.value != '') {
                    $("<a href='#' >" + R.view + "</a>")
                        .on('click', function (e) {
                            properties.popup.option('title', options.column.caption);
                            properties.popup.show();
                            $('#' + properties.scrollViewContentElementId).html(options.value);
                            e.preventDefault();
                        })
                        .appendTo(container);
                }
            };
            break;
        }
        case "YesNo":{
            column.falseText = R.label_no;
            column.trueText = R.label_yes;
            column.cellTemplate = function (container, options) {
                if (options.value && options.value != '') {
                    (container).html(R.label_yes);
                }
                else if(options.value === false) {
                    (container).html(R.label_no);
                }
                else {
                    (container).html(" ");
                }
            };
            column.dataType = 'boolean';
            break;
        }
        case "Boolean":
            break;
        case "CheckBox":
            break;
        case "MaskedTextBox":
            break;
        case "Section":
            column.allowFiltering = true;
            column.dataType = 'string';
            break;
        case "MultiLineTextBox":
            // https://www.devexpress.com/Support/Center/Question/Details/T298005
            break;
        case "Date":{
            column.dataType = 'date';
            column.calculateCellValue = function (rowData) {
                var value = get_json_data_using_field_paths(column.dataField, rowData);
                if ('string' == typeof value){
                    value = moment.utc(value).format('MM/DD/YY');
                }
                else if (!value){
                    value = '';
                }
                return value;
            };
            break;
        }
        case "percent":{
            column.format = {
                type: 'percent', precision: 2
            };
            column.dataType = 'number';
            column.calculateFilterExpression = function (filterValue, filterOperation) {
                return [this.dataField, filterOperation || '=', filterValue / 100];
            };
            break;
        }
        case "currency":{
            column.format = {
                type: 'currency', precision: 2
            };
            column.dataType = 'number';
            break;
        }
        case "Number":{
            column.dataType = 'number';
            break;
        }
        case "DateTimeLocal":{
            column.dataType = 'date';
            column.calculateCellValue = function (rowData) {
                var value = get_json_data_using_field_paths(column.dataField, rowData);
                return value?moment(value).format('MM/DD/YY hh:mm a'):'';
            };
            break;
        }
        case "DateTime":{
            column.dataType = 'date';
            column.calculateCellValue = function (rowData) {
                var value = get_json_data_using_field_paths(column.dataField, rowData);
                return value?moment(value).format('MM/DD/YY hh:mm a'):'';
            };
            break;
        }
        case "Time":{
            column.calculateCellValue = function (rowData) {
                var value = get_json_data_using_field_paths(column.dataField, rowData);
                return value?moment(value).format('hh:mm:ss a'):'';
            };
            break;
        }
        case "user": {
            if (attribute.is_nested_entity && attribute.data_is_nested == false && !attribute.is_array) {
                column.allowFiltering = true;
                column.dataType = 'string';
                column.cellTemplate = function (container, options) {
                    var avatar_out='data:image/png;base64,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';
                    if (typeof options.value == "object" && options.value != null) {
                        var name = options.value.caption || options.value.entity_id;
                        var iconUser=options.value.image;
                        var html1='<span style="margin-top:5px;text-align:left;">' + name + '</span>';
                        var html2 = iconUser == undefined ? '<i class="fa fa-user" style="margin-right:5px;;margin-left:5px;font-size:18px;" aria-hidden="true">' :  "<div style='background-image:url("+iconUser+");background-repeat:none;background-position:center center;width:25px;height:25px;float:left;margin-right:5px;background-size:cover;'></div>";
                        if (iconUser) {
                            if( (avatar_out == options.value.image)  ) iconUser='';
                            if(!iconUser){
                                $("<span>&nbsp;</span>").prependTo(container);
                                $('<i class="fa fa-user" style="float:left;font-size:18px;" aria-hidden="true"></i>').prependTo(container);
                            }
                            else{
                                $("<span>&nbsp;</span>").prependTo(container);
                            }
                        }
                        else{
                            $("<span>&nbsp;</span>").prependTo(container);
                            $('<i class="fa fa-user" style="float:left;  font-size:18px;margin-left:5px;" aria-hidden="true"></i>').prependTo(container);
                        }
                        container.html('<table  width="100%" height="100%" cellpadding="0" cellspacing="0" ><tr><td valign="center" width="10" >'+ html2 +' </td> <td valign="center" style="text-align:left;margin-left:5px;"> '+html1+'</td></tr></table>');
                        options.displayValue = name;
                        options.value = name;
                        if (attribute.primary_key || attribute.display_as_primary_key) {
                            container.addClass('dx-link')
                                .on('dxclick', function () {
                                    properties.launch_edit_form(options.data);
                                })
                                .appendTo(container);
                        }
                    }
                    else{
                        if (attribute.primary_key || attribute.display_as_primary_key) {
                            container.addClass('dx-link')
                                .text(options.text || options.value)
                                .on('dxclick', function () {
                                    properties.launch_edit_form(options.data);
                                })
                                .appendTo(container);
                        }
                        return options.value;
                    }
                };
                column.customizeText = function (data) {
                    if (!data || !data.value || !data.value.caption) {
                        if(properties.disallow_null_captions) {
                            return R.label_chart_series_no_value || "(None)";
                        }
                        return null;
                    }
                    if(properties.disallow_null_captions && (data.value.caption == "")) {
                        return R.label_chart_series_no_value || "(None)";
                    }
                    return data.value.caption;
                };
            }
            break;
        }
        case "String": {
            column.dataType = 'string';
            if (properties.app_object && properties.app_object.workflow_states && (column.dataField == "workflow_status")) {
                column.cellTemplate = function (container, options) {
                    var workflowState = properties.app_object.workflow_states[options.value];
                    if ((workflowState && workflowState.caption && (workflowState.caption.trim() != ""))) {
                        var class_name = "label label-";
                        if (workflowState && workflowState.view_options && workflowState.view_options.class_color) {
                            class_name = class_name + workflowState.view_options.class_color;
                        }
                        else {
                            class_name = class_name + "palegreen";
                        }
                        (container).html("<span><span class='" + class_name + "'>" + workflowState.caption.toUpperCase() + "</span></span>");
                    }
                };
                var workflow_states_dictionary = properties.app_object.workflow_states || {};
                column.customizeText = function(cellInfo) {
                    if(cellInfo.value) {
                        var value_obj = workflow_states_dictionary[cellInfo.value];
                        if(value_obj && value_obj.caption && (value_obj.caption.trim != "")) {
                            return value_obj.caption;
                        }
                    }
                    if(properties.disallow_null_captions && (!cellInfo.valueText || (cellInfo.valueText == ""))) {
                        return R.label_chart_series_no_value || "(None)";
                    }

                    return cellInfo.valueText;
                };

                if (!properties.disallow_workflow_states_filter) {
                    var workflowStates = [];
                    for (var propertyName in workflow_states_dictionary) {
                        if(workflow_states_dictionary.hasOwnProperty(propertyName) && workflow_states_dictionary[propertyName]) {
                            var workflowState = workflow_states_dictionary[propertyName];
                            if (workflowState.caption && (workflowState.caption.trim() != "")) {
                                workflowStates.push({value: workflowState.caption, code: propertyName});
                            }
                        }
                    }
                    if (workflowStates.length > 0) {
                        column.lookup = {
                            dataSource: workflowStates,
                            valueExpr: 'code',
                            displayExpr: 'value'
                        };
                    }
                }
            }
            if ( attribute.list_of_values ) {
                if ( properties.app_object ) {
                    if ( properties.app_object.entity == "xenforma_note" ) {
                        column.visible = attribute.list_visible;
                        column.dataType = 'data';
                    }
                }
                var valuesList = attribute.list_of_values;
                if ( Array.isArray(valuesList) ) {
                    column.lookup = {dataSource: valuesList, valueExpr: 'code', displayExpr: 'value'};
                    column.customizeText = function(cellInfo) {
                        if ( valuesList && cellInfo.value ) {
                            var value_obj = first_where(valuesList, function(a) {
                                return (a && a.code == cellInfo.value);
                            });
                            if ( value_obj ) {
                                if(properties.disallow_null_captions && (!value_obj.value || (value_obj.value == ""))) {
                                    return R.label_chart_series_no_value || "(None)";
                                }
                                return value_obj.value;
                            }
                        }
                        if ( properties.disallow_null_captions && (!cellInfo.valueText || (cellInfo.valueText == "")) ) {
                            return R.label_chart_series_no_value || "(None)";
                        }
                        return cellInfo.valueText;
                    };
                }
            }
            break;
        }
        default:{
            if ( attribute.db_type == "Number" ) {
                column.dataType = 'number';
                break;
            }
            if ( !attribute.is_array ) {
                column.allowFiltering = true;
                column.dataType = 'string';
            }
            if ( attribute.is_nested_entity && !attribute.data_is_nested ) {
                //column is a nested entity
                column.calculateCellValue = function (rowData) {
                    var value = get_json_data_using_field_paths(column.dataField, rowData);
                    if ( value ) {
                        var name = value.value || value.caption;
                        return name;
                    }
                    return value;
                };
                column.reference_type = type;
                if ( allow_column_edit ) {
                    column.cellTemplate = function (cellElement, cellInfo) { //Not clickable
                        cellElement.addClass('img-container');
                        cellElement.text(cellInfo.value)
                            .appendTo(cellElement);
                        var cellData = cellInfo.data[cellInfo.column.dataField];
                        var image = cellData ? cellData.image : null;
                        if (image) {
                            $('<img style=height:21px;margin-right:3px />')
                                .attr("src", image)
                                .prependTo(cellElement);
                        }
                    };
                    column.editCellTemplate = function (cellDataSource) {
                        return function (cellElement, cellInfo) {
                            var divElement = document.createElement("div");
                            cellElement.html(divElement);
                            ReactDOM.render(<EditorDevExtremeLookup
                                dataSource={cellDataSource}
                                displayExpr="caption"
                                valueExpr="entity_id"
                                value={cellInfo.value||''}
                                add_button={false}
                                edit_button={false}
                                readOnly={false}
                                is_in_grid_edit={true}
                                onDisposing={function() {
                                    if(cellInfo.key) {
                                        properties.change_workflow_button_count(false, cellInfo.column.dataField + cellInfo.key);
                                    }
                                    properties.run_selection_buttons_display_logic();
                                }}
                                onChange={function(new_value) {
                                    properties.data_grid_view_component.force_edit_refresh = true;
                                    var cell_value = new_value;
                                    if(new_value && (typeof new_value == "object") && !new_value.caption && cellDataSource && cellDataSource._items && cellDataSource._items.filter) {  //for some reason this object does not have the caption, so we have to grab it from the data source
                                        cell_value = cellDataSource._items.filter(function(a) {return a.entity_id == new_value.entity_id});
                                        if(cell_value && cell_value.length) {
                                            cell_value = cell_value[0];
                                        }
                                        else {
                                            cell_value = new_value;
                                        }
                                    }
                                    cellInfo.setValue(cell_value);
                                }}
                                placeholder={R.start_typing_to_search?R.start_typing_to_search:'Start typing to search...'}
                            />, divElement);
                        };
                    }(properties.build_datasource(column.reference_type, attribute.field_path, false));
                }
                else if(attribute.read_only && !attribute.allow_edit_from_read_only) {
                    column.cellTemplate = function (cellElement, cellInfo) {
                        cellElement.addClass('img-container');
                        cellElement.text(cellInfo.value)
                            .appendTo(cellElement);
                        var cellData = cellInfo.data[cellInfo.column.dataField];
                        var image = cellData ? cellData.image : null;
                        if (image) {
                            $('<img style=height:21px;margin-right:3px />')
                                .attr("src", image)
                                .prependTo(cellElement);
                        }
                    };
                }
                else {
                    column.cellTemplate = function (cellElement, cellInfo) {
                        cellElement.addClass('img-container');
                        cellElement.addClass('dx-link')
                            .text(cellInfo.value)
                            .on('dxclick', function () {
                                if(cellInfo.data[cellInfo.column.dataField]) {
                                    var app_object = {
                                        code: cellInfo.column.reference_type + '_default_edit_form',
                                        _id: cellInfo.data[cellInfo.column.dataField].entity_id
                                    };
                                    properties.call_data_list_set_state({ editForm: app_object });
                                }
                            })
                            .appendTo(cellElement);
                        var cellData = cellInfo.data[cellInfo.column.dataField];
                        var image = cellData ? cellData.image : null;
                        if (image) {
                            $('<img style=height:21px;margin-right:3px />')
                                .attr("src", image)
                                .prependTo(cellElement);
                        }
                    };
                }
            }
            else if (attribute.entity_reference_variant){
                column.calculateCellValue = function (rowData) {
                    var value = get_json_data_using_field_paths(column.dataField, rowData);
                    if (value) {
                        var name = value.value || value.caption;
                        return name;
                    }
                    return value;
                };
                column.reference_type = type;
                column.allowEditing = false;
                allow_column_edit = false;
                column.cellTemplate = function (cellElement, cellInfo){
                    cellElement.addClass('img-container');
                    cellElement.addClass('dx-link')
                        .text(cellInfo.value)
                        .on('dxclick', function () {
                            var app_object = {
                                code : cellInfo.data[cellInfo.column.dataField].entity_name + '_default_edit_form',
                                _id : cellInfo.data[cellInfo.column.dataField].entity_id
                            };
                            properties.call_data_list_set_state({ editForm: app_object });
                        })
                        .appendTo(cellElement);
                    var cellData = cellInfo.data[cellInfo.column.dataField];
                    var image = cellData?cellData.image:null;
                    if (image){
                        $('<img style=height:21px;margin-right:3px />')
                            .attr("src", image)
                            .prependTo(cellElement);
                    }
                }
            }
            else if (attribute.primary_key || attribute.display_as_primary_key) {
                create_clickable_column_for_opening_this_entity(properties, column, type, allow_column_edit);
            }
            else {
                column.calculateCellValue = function (rowData) {
                    var value = get_json_data_using_field_paths(column.dataField, rowData);
                    return value;
                };
                column.customizeText = function (cellInfo) {
                    if (typeof cellInfo.value == "object" && cellInfo.value != null) {
                        var name = cellInfo.value.caption || cellInfo.value.entity_id;
                        if(properties.disallow_null_captions && (!name || (name == ""))) {
                            return R.label_chart_series_no_value || "(None)";
                        }
                        return name;
                    } else {
                        if(properties.disallow_null_captions && (!cellInfo.valueText || (cellInfo.valueText == ""))) {
                            return R.label_chart_series_no_value || "(None)";
                        }
                        return cellInfo.valueText;
                    }
                }
            }
            break;
        }
    }
    if(allow_column_edit) {
        column.allow_column_edit = true;
    }
    if(properties.disallow_null_captions) {
        if(!column.customizeText) { //First, replace the tendency of the pivotGrid to autoname null values as "Series (n)"
            column.customizeText = function (rowData) {
                if((rowData.valueText == null) || rowData.valueText == "") {
                    return R.label_chart_series_no_value || "(None)";
                }
                return rowData.valueText;
            };
        }
    }
    return column;
}

function create_clickable_column_for_opening_this_entity(properties, column, type, allow_column_edit) {
    //column is the key field
    column.calculateCellValue = function (rowData) {
        var value = get_json_data_using_field_paths(column.dataField, rowData);
        if (typeof value == "object" && value != null) {
            var name = value.caption || value.entity_id;
            return name;
        } else {
            return value;
        }
    };
    column.reference_type = type;
    if(!allow_column_edit) {  //make this a hyperlink
        column.cellTemplate = function (cellElement, cellInfo) {
            cellElement.addClass('dx-link')
                .text(cellInfo.text || cellInfo.value)
                .on('dxclick', function () {
                    properties.launch_edit_form(cellInfo.data);
                })
                .appendTo(cellElement);
        };
    }
    column.customizeText = function (cellInfo) {
        if (typeof cellInfo.value == "object" && cellInfo.value != null) {
            var name = cellInfo.value.caption || cellInfo.value.entity_id;
            if(properties.disallow_null_captions && (!name || (name == ""))) {
                return R.label_chart_series_no_value || "(None)";
            }
            return name;
        }
        else {
            if(properties.disallow_null_captions && (!cellInfo.valueText || (cellInfo.valueText == ""))) {
                return R.label_chart_series_no_value || "(None)";
            }
            return cellInfo.valueText;
        }
    }
}

function autosize_dropdown_list_width_by_options(ev) {
    var list = $(ev.component._$list).find('.dx-scrollview-content').children();
    if (list.length) {
        var css_list = [];
        for(var i = 0; i < list.length; i++) {
            var list_item = list[i];
            if(list_item && list_item.innerHTML && list_item.innerHTML.length) {
                var o = $('<div>' + list_item.innerHTML + '</div>') //find the width of this DOM element
                        .css({'position': 'absolute', 'float': 'left', 'white-space': 'nowrap', 'visibility': 'hidden'})
                        .appendTo($('body')),
                    w = o.width();
                o.remove();
                //or:
                /*this.hidden_canvas_context = this.hidden_canvas_context || (document.createElement("canvas").getContext("2d"));
                 this.hidden_canvas_context.font = font;
                 var w = this.hidden_canvas_context.measureText(list_item.innerText).width;*/
                css_list.push(w || (list_item.innerText.length * 10));
            }
        }
        var max_width = css_list.reduce(function(max_length, current_value) {if(current_value && (current_value > max_length)) {return current_value;} return max_length;}, 0);
        setTimeout(function() {
            try {
                ev.component.content().parent().width(max_width + 25); //Add 25 to projected width, just to prevent an accidental cutoff
            }
            catch(ex) {

            }
        });
    }
}

function browser_is_mobile() {
    var isMobile = !!(/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone/i.test(navigator.userAgent));
    isMobile = isMobile || document.documentElement.clientWidth <= 800;
    return isMobile;
}



function print_reports(win, selected_id_arr, report_array, callback) {
    if(!report_array || !report_array.length || !selected_id_arr || !selected_id_arr.length) {
        if ( win ) {
            win.close();
        }
        if (callback) {
            callback();
        }
        return;
    }

    if(win) {
        //Set a loading screen while we wait for response
        win.document.write("<div style='position: absolute; top:0; left:0; width:100%; height:100%'><div style='width:100%; height:100%; background-color: rgb(93,178,255)'><img style='max-width:100%; height:30px; margin:0 auto; position: relative; display: block; padding-bottom: 10px; top: 50%;' src='css/icons/LoadingL.gif' alt='" + R.label_loading + "' loop='infinite'/></div></div>");
    }

    var isList = (selected_id_arr.length > 1);
    var isChrome = isChromeNavigator();
    var error = function (err) {
        if ( win ) {
            win.close();
        }
        if ( callback ) {
            callback(err);
        }
    };
    var success = function (e) {
        if ( e.data ) {
            var redirect = function(data){
                var filename = data.download_name || data.redirect_url;
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = function () {
                    var a = document.createElement('a');
                    a.href = (window.URL || window.webkitURL || {createObjectURL: function(){}}).createObjectURL(xhr.response); // xhr.response is a blob
                    a.download = filename; // Set the file name.
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                };
                xhr.open('GET', e.data.redirect_url);
                xhr.send();
            };

            if (e.data.redirect_url || (e.data.downloads && e.data.downloads.length)) {
                if ( e.data.downloads && e.data.downloads.length ) {
                    if ( win ) win.location.assign(e.data.downloads[0].redirect_url);
                    for ( var i = 1, u = e.data.downloads.length; i<u; i++ ) {
                        window.open(e.data.downloads[i].redirect_url);
                    }
                }

                if ( win && e.data.redirect_url ) {
                    redirect(e.data);
                }
            }
            else if (isChrome) { //Chrome does not use the popup for html printing
                if(win) {
                    win.close();
                }
                win = null;
            }

            if ( e.data.html ) {
                if ( !isChrome && win ) {
                    win.document.write(e.data.html);
                    $(win).load(function () {
                        //var this_report_object = general_utils.first_where(function(a) {return (a (a.report_code == ???) && (a.report_caption));});
                        //win.document.title = this_report_object.report_caption;
                        win.print();
                        win.close();
                    });
                    win.document.close();
                    win.focus();
                }
                else {
                    var frame1 = document.createElement('iframe');
                    frame1.name = "frame1";
                    frame1.style.position = "absolute";
                    frame1.style.top = "-1000000px";
                    window.document.body.appendChild(frame1);
                    var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                    frameDoc.document.open();
                    frameDoc.document.write(e.data.html);
                    frameDoc.document.close();
                    //frameDoc.title = report_caption;

                    setTimeout(function () {
                        window.frames["frame1"].focus();
                        window.frames["frame1"].print();
                        window.document.body.removeChild(frame1);
                    }, 500);
                }
            }
        }

        if ( callback ) {
            callback();
        }
    };

    var conditions;
    if (isList) {
        conditions = {"_id": {"$in": selected_id_arr}};
    }

    var send_data = {};
    send_data.report_app_object_codes = report_array.map(function(a) {return a.report_code;});

    if ( isList ) {
        send_data.report_type = 'list';
        send_data.conditions = conditions;
    }
    else {
        send_data._id = selected_id_arr[0];
    }

    invoke_method("app_object", "get_by_code", send_data, success, error);
}

function isChromeNavigator() {
    var isChromium = window.chrome,
        winNav = window.navigator,
        vendorName = winNav.vendor,
        isOpera = winNav.userAgent.indexOf("OPR") > -1,
        isIEedge = winNav.userAgent.indexOf("Edge") > -1,
        isIOSChrome = winNav.userAgent.match("CriOS");

    return isIOSChrome || (isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera == false && isIEedge == false);
}

function isEmailAttributeValid(attribute_value) {
    return attribute_value.match(/^[A-Z0-9._%+-]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/gi);
}
